module.exports = __webpack_public_path__ + "static/img/20.db76fbd4.jpg";